import React from 'react';
import styled from '@emotion/styled';
import SEOHelmet from './SEOHelmet';
import { Link } from 'react-router-dom';

const NotFoundContainer = styled.div`
  text-align: center;
  padding: 4rem 1rem;
`;

const Title = styled.h1`
  font-size: 4rem;
  font-weight: 300;
  margin-bottom: 2rem;
  color: var(--text-primary);
  text-shadow: 0 0 20px rgba(157, 78, 221, 0.3);
`;

const Message = styled.p`
  font-size: 1.25rem;
  color: var(--text-secondary);
  margin-bottom: 2rem;
`;

const HomeLink = styled(Link)`
  color: var(--accent-primary);
  text-decoration: none;
  font-size: 1.1rem;
  transition: all 0.3s ease;
  
  &:hover {
    color: var(--accent-secondary);
    text-shadow: 0 0 8px rgba(157, 78, 221, 0.3);
  }
`;

function NotFound() {
  return (
    <>
      <SEOHelmet 
        title="404 - Page Not Found | Big Brain"
        description="The page you're looking for doesn't exist."
        canonicalUrl="https://bigbrainthings.xyz/404"
      />
      
      <NotFoundContainer>
        <Title>404</Title>
        <Message>Oops! The page you're looking for doesn't exist.</Message>
        <HomeLink to="/">Return to Home</HomeLink>
      </NotFoundContainer>
    </>
  );
}

export default NotFound; 